import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import AOS from "aos";
import "aos/dist/aos.css";

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: '#9744ED',
  },
  containerLogo: {
    marginBottom: '25rem',
  },
  toptitle : {
    fontSize : '25px',
    backgroundColor : '#FFF',
    color : '#000',
    position: 'fixed',
    top : 0,
    width : '100%',
    padding : '10px',
    paddingLeft : '15px'


  },
  imageSize: {
    width: '250px',
    height: '250px',
  },
  containerForm: {
    backgroundColor: '#FFF',
    borderRadius: '25px 25px 0 0',
    padding: '2rem',
    textAlign: 'center',
    position : 'fixed',
    bottom : 0,
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginTop: '1rem',
    marginBottom: '0.5rem',
    color : '#000'
  },
  subTitle: {
    fontSize: '16px',
    color: '#a1a1a1',
    marginBottom: '1rem',
  },
  button: {
    width: '60%',
    fontSize: '18px',
    backgroundColor: '#9756F0',
    borderRadius: '50px',
    border : 0,
    padding: '8px',
    marginBottom: '1rem',
    color: '#FFF',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
};

const Welcome = (props) => {

  useEffect(() => {
    AOS.init();
  }, []);

  return  (
    <div className="container">
      <div className="toptitle" >
        welcome
      </div>
      
      <div style={styles.containerLogo} data-aos="">
          <img style={styles.imageSize} src={process.env.PUBLIC_URL + '/images/512.png'} alt="Logo" data-aos="slide-down" data-aos-duration="1400"/>
      </div>
  

      <div style={styles.containerForm} data-aos="slide-up" data-aos-duration="1400">
        <p style={styles.title}>
          This Wallet is official Mdti wallet where you can monitory prices of MDTI
        </p>
        <p className='subTitle'>Login to start</p>

        <NavLink to="/login">
          <button className="button">
            로그인
          </button>
        </NavLink>
        <NavLink to="/register">
          <button className="button">
            회원 가입
          </button>
        </NavLink>
      </div>
    </div>
  );
};

const mapStateToProps = ({ authUser }) => {
  const { currentUser } = authUser;
  return {currentUser}
};

export default connect(mapStateToProps, null)(Welcome);

